import React from 'react';
import {
  BucketCardColors,
  BucketInteractionState,
  InvoiceSummaryBucketCardBase,
} from '@finance-hub/domain/invoicing/components/invoice-summary-bucket-card-base';
import { getInvoiceSummaryAmountSize } from '@finance-hub/domain/invoicing/blocs/utils/invoice-summary-amount-size-utils';
import {
  InvoiceSummaryAmountBucket,
  InvoiceSummaryAmountVariant,
} from '@finance-hub/domain/invoicing/blocs/types/invoice-summary';

export const AMOUNT_BUCKET_MIN_WIDTH = 132;

const AMOUNT_SIZE_CEILING = '$xl';

interface Props extends Omit<InvoiceSummaryAmountBucket, 'filter'> {
  interactionState: BucketInteractionState;
  longestAmountLength: number;
  onPress: () => void;
}

const COLORS_BY_VARIANT: Record<InvoiceSummaryAmountVariant, BucketCardColors> =
  {
    credit: {
      activeBorderColor: '$textSuccess',
      backgroundColor: '$bgSuccess',
      borderColor: '$green3',
      countColor: '$textSecondary',
      labelColor: '$textSecondary',
      textColor: '$textSuccess',
    },
    neutral: {
      activeBorderColor: '$textPrimary',
      backgroundColor: '$bgPrimaryDefault',
      borderColor: '$borderPrimary',
      countColor: '$textPrimary',
      labelColor: '$textSecondary',
      textColor: '$textPrimary',
    },
    overdue: {
      activeBorderColor: '$textError',
      backgroundColor: '$bgError',
      borderColor: '$red3',
      countColor: '$textSecondary',
      labelColor: '$textSecondary',
      textColor: '$textError',
    },
  };

/** A headline total card (Total Due / Overdue / Total Credits). */
export const InvoiceSummaryAmountBucketCard: React.FC<Props> = ({
  longestAmountLength,
  variant,
  ...cardProps
}) => {
  return (
    <InvoiceSummaryBucketCardBase
      {...cardProps}
      amountSize={getInvoiceSummaryAmountSize(
        longestAmountLength,
        AMOUNT_SIZE_CEILING,
      )}
      colors={COLORS_BY_VARIANT[variant]}
      minWidth={AMOUNT_BUCKET_MIN_WIDTH}
    />
  );
};
